module.exports = __webpack_public_path__ + "media/warranty/warranty-registered-icon-072dd271.png";